import React from 'react'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import AddCircleIcon from '@material-ui/icons/AddCircle'

interface Props {
  onClick(): void,
  children?: React.ReactNode,
}
const CompCreateButton = (props: Props) => {
  const {
    onClick,
    children,
  } = props
  return <Wrapper
    startIcon={<AddCircleIcon />}
    onClick={onClick}
  >
    { children }
  </Wrapper>
}

const Wrapper = styled(Button)`
  color: #009688;
  background-color: #E7F4F2;
` as typeof Button

export default CompCreateButton